export default __webpack_public_path__ + "static/media/expert_banner2.02757e78.png";